export const globalMixin = {
  methods: {
    abbrevTo: function (value, digits = 2) {
      var units = ["K", "M", "B", "t", "q", "Q", "s", "S"],
        decimal;

      for (var i = units.length - 1; i >= 0; i--) {
        decimal = Math.pow(1000, i + 1);

        if (value <= -decimal || value >= decimal) {
          return +(value / decimal).toFixed(digits) + units[i];
        }
      }
      return value;
    },
    albumTo: function (values) {
      if (values.length > 4) {
        return values.slice(0, 4);
      } else {
        return values;
      }
    },
    numberTo: function (value, precision = 2) {
      if (!value) return "0";
      return value.toLocaleString(undefined, {
        maximumFractionDigits: precision,
      });
    },
    percentageTo: function (value, precision = 2) {
      if (!value) return "0.0%";
      const number = parseFloat(value);
      if (isNaN(number)) return "0.0%";

      if (number <= 0.01 && number > 0) {
        precision = 3;
      }

      if (Math.abs(number) >= 100) {
        const value = number < 1000 ? parseInt(number) : number;
        return this.abbrevTo(value, precision) + "%";
      }

      return (number / 100).toLocaleString(
        document.documentElement.lang.split("-")[0],
        {
          style: "percent",
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
        }
      );
    },
    stringTo: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    timeTo: function (value) {
      if (!value) return "0 sec";

      const seconds = parseInt(value, 10);

      const units = [
        [86400, 'day'],
        [3600, 'hour'],
        [60, 'min'],
        [1, 'sec']
      ];

      let parts = [];
      let partsRemaining = seconds;

      for (const [divisor, unit] of units) {
        if (partsRemaining < divisor) continue;

        const count = Math.floor(partsRemaining / divisor);
        parts.push(this.pluralize(count, unit));
        partsRemaining %= divisor;

        if (parts.length === 2) break;
      }

      return parts.join(' and ');
    },
    getChannelName(value) {
      switch (value.trim().toLowerCase()) {
        case "facebook":
          return "Facebook";
        case "instagram":
          return "Instagram";
        case "twitter":
          return "X";
        case "linkedin":
          return "LinkedIn";
        case "youtube":
          return "YouTube";
        case "tiktok":
          return "TikTok";
        default:
          return value;
      }
    },
    getPollPercentage(voteCount, options) {
      if (!options?.length) return 0;

      const optionVotes = Math.max(0, Number(voteCount) || 0);
      const totalVotes = options.reduce((sum, option) => sum + Math.max(0, Number(option.voteCount) || 0), 0);

      return totalVotes === 0 ? 0 : Math.round((optionVotes / totalVotes) * 100);
    },
    toggleArrow(id) {
      const anchorElement = document.getElementById(id);
      if (!anchorElement) return "";

      const iTag = anchorElement.querySelector("i");
      if (!iTag) return "";

      if (iTag.classList.contains("fa-expand-less")) {
        iTag.classList.remove(...iTag.classList);
        iTag.classList.add("fa");
        iTag.classList.add("fa-expand-more");
      } else {
        iTag.classList.remove(...iTag.classList);
        iTag.classList.add("fa");
        iTag.classList.add("fa-expand-less");
      }
    },
    truncateText(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    pluralize: function(count, unit) {
      return count === 1 ? `${count} ${unit}` : `${count} ${unit}s`;
    },
    truncate(value, limit = 100) {
      if (!value) return '';
      if (value.length > limit) {
        value = value.substring(0, limit - 3) + '...';
      }
      return value;
    }
  }
};

// Global filters
export const globalFilters = {
  capitalize: function (value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },
  truncate: function (value, limit = 100) {
    if (!value) return "";
    if (value.length > limit) {
      value = value.substring(0, limit - 3) + "...";
    }
    return value;
  }
};